
var void0 = function(){};
var lang = document.documentElement.lang;
var winW = 0;
var winH = 0;
var winX = 0;
var winY = 0;
var modeResp = false;
var modeMobile = false;
var PAGE_HASH = window.location.hash;
var SITE_HOST = window.location.origin;

function run(fn) {try {fn();} catch (er) {console.warn(er);}}

function refreshPage() {
    window.location.reload();
}

function checkWindow() {
    winW = window.innerWidth;
    winH = window.innerHeight;
    modeResp = winW < 600;
    
    var userAgent = navigator.userAgent;
    modeMobile = !!(userAgent.indexOf('Android') > -1 || userAgent.match(/(iPad|iPhone|iPod)/i));
}

function writeResolution() {
    var el = document.querySelector(".resolution");
    if (el) el.innerHTML = winW + " x " + winH;
}

function blackout2(active) {
    document.getElementById("blackout2").style.display = active ? "block" : "none";
}

function sendEmail(email, personId, subject, message, file, fields, callback) {
    var params = {
        email: email,
        personId: personId,
        subject: subject,
        file: file
    };
    if (message) {
        params.message = message;
    }
    for (var key in fields) {
        if (fields.hasOwnProperty(key) && /^field[123456]$/.test(key)) {
            params[key] = fields[key];
        }
    }
    $.ajax({
        url: "/action/sendEmail",
        method: "post",
        data: params,
        complete: function(response) {
            console.log(response.responseText);
            callback();
        }
    });
};


function initSlick(slider, responsive, options) {
    slider = slider ? slider : $('.slick-init');
    
    options = (options === undefined) ? {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        autoplay: false,
        speed: 750,
        responsive: [
            responsive
        ]
    } : options;
    
    var arrows = (slider.attr("data-arrows") === 'true') ? ({
        prevArrow: ".slick-slider-btn.prev",
        nextArrow: ".slick-slider-btn.next",
        arrows: true
    }) : {arrows: false};
    
    var dots = (slider.attr("data-dots") === "true") ? ({
        dots: true
    }) : {};
    
    var auto = (slider.attr("data-autoplay") === "true") ? ({
        autoplay: true
    }) : {};
    
    $.extend(true, options, arrows);
    $.extend(true, options, dots);
    $.extend(true, options, auto);
    
    var slick = slider.slick(
            options);
    
}
